import { apiFetch } from "./apiClient";

const BASE = "/api/services/service-plans";

export async function getServicePlanTemplates(filters = {}) {
  const params = new URLSearchParams();

  if (filters.customerId !== undefined && filters.customerId !== null) {
    params.set("customer_id", filters.customerId);
  }
  if (filters.customerId === null) {
    params.set("customer_id", "null");
  }
  if (filters.serviceTypeId != null) {
    params.set("service_type_id", filters.serviceTypeId);
  }
  if (filters.active != null) {
    params.set("active", String(filters.active));
  }
  if (filters.templateName) {
    params.set("template_name", filters.templateName);
  }
  if (filters.versionNo != null) {
    params.set("version_no", filters.versionNo);
  }

  const query = params.toString() ? `?${params.toString()}` : "";
  const res = await apiFetch(`${BASE}/templates${query}`);
  if (!res.ok) {
    throw new Error("Failed to fetch service plan templates");
  }
  return res.json();
}

export async function getServicePlanTemplateById(
  templateId,
  options = { includeInactiveTasks: true },
) {
  const params = new URLSearchParams();
  if (options.includeInactiveTasks === false) {
    params.set("include_inactive_tasks", "false");
  }

  const query = params.toString() ? `?${params.toString()}` : "";
  const res = await apiFetch(`${BASE}/templates/${templateId}${query}`);
  if (!res.ok) {
    throw new Error("Failed to fetch service plan template");
  }
  return res.json();
}

export async function createServicePlanTemplate(payload) {
  const res = await apiFetch(`${BASE}/templates`, {
    method: "POST",
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Failed to create service plan template");
  }

  return res.json();
}

export async function updateServicePlanTemplate(templateId, payload) {
  const res = await apiFetch(`${BASE}/templates/${templateId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Failed to update service plan template");
  }

  return res.json();
}

export async function syncServicePlanTemplateFutureJobs(
  templateId,
  payload = {},
) {
  const res = await apiFetch(
    `${BASE}/templates/${templateId}/sync-future-jobs`,
    {
      method: "POST",
      body: JSON.stringify(payload),
    },
  );

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(
      err.error || "Failed to sync future jobs for service plan template",
    );
  }

  return res.json();
}
